import { createFileRoute } from '@tanstack/react-router'

import { Home } from '~/pages/Home/Index'

export const Route = createFileRoute('/_authenticated/')({
  component: () => <Home />,
})
